import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface ICorpRiskLevel {
  /**
   * 风险等级数字描述，如 8
   *
   * @type {string}
   * @memberof ICorpRiskLevel
   */
  corpRiskLevel: string
  /**
   * 风险等级英文描述，如 C3
   *
   * @type {string}
   * @memberof ICorpRiskLevel
   */
  corpRiskName: string
}

interface ICorpRiskLevelResponse {
  success?: (result: ICorpRiskLevel) => void
  fail?: (result: ICorpRiskLevel) => void
  complete?: (result: ICorpRiskLevel) => void
}

/**
 * 获取用户风险等级
 *
 * @param {IBridgeOptions<ICorpRiskLevelResponse>} {
 *   success,
 *   fail,
 *   complete
 * }
 */
function getUserCorpRiskLevelSync({
  success,
  fail,
  complete
}: IBridgeOptions<ICorpRiskLevelResponse>) {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getCorpRiskLevel'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('getUserCorpRiskLevelSync error: ', error)
  }
}

/**
 * 获取用户风险等级<br>
 * 一个异步接口，支持 Promise 化使用
 *
 * @returns {Promise<ICorpRiskLevel>}
 */
function getUserCorpRiskLevel(): Promise<ICorpRiskLevel> {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getCorpRiskLevel'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export { getUserCorpRiskLevel, getUserCorpRiskLevelSync }
